// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eLT2","controls":"styles_controls__3oIgE","charLimit":"styles_charLimit__3azO0","input":"styles_input__-iak5","send":"styles_send__2QOsF"};